import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Cog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTAuMjcgNyAzLjM0IiAvPgogIDxwYXRoIGQ9Im0xMSAxMy43My00IDYuOTMiIC8+CiAgPHBhdGggZD0iTTEyIDIydi0yIiAvPgogIDxwYXRoIGQ9Ik0xMiAydjIiIC8+CiAgPHBhdGggZD0iTTE0IDEyaDgiIC8+CiAgPHBhdGggZD0ibTE3IDIwLjY2LTEtMS43MyIgLz4KICA8cGF0aCBkPSJtMTcgMy4zNC0xIDEuNzMiIC8+CiAgPHBhdGggZD0iTTIgMTJoMiIgLz4KICA8cGF0aCBkPSJtMjAuNjYgMTctMS43My0xIiAvPgogIDxwYXRoIGQ9Im0yMC42NiA3LTEuNzMgMSIgLz4KICA8cGF0aCBkPSJtMy4zNCAxNyAxLjczLTEiIC8+CiAgPHBhdGggZD0ibTMuMzQgNyAxLjczIDEiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/cog
 * @see https://lucide.dev/guide/packages/lucide-react-native - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cog = createLucideIcon('Cog', [
  ['path', { d: 'M11 10.27 7 3.34', key: '16pf9h' }],
  ['path', { d: 'm11 13.73-4 6.93', key: '794ttg' }],
  ['path', { d: 'M12 22v-2', key: '1osdcq' }],
  ['path', { d: 'M12 2v2', key: 'tus03m' }],
  ['path', { d: 'M14 12h8', key: '4f43i9' }],
  ['path', { d: 'm17 20.66-1-1.73', key: 'eq3orb' }],
  ['path', { d: 'm17 3.34-1 1.73', key: '2wel8s' }],
  ['path', { d: 'M2 12h2', key: '1t8f8n' }],
  ['path', { d: 'm20.66 17-1.73-1', key: 'sg0v6f' }],
  ['path', { d: 'm20.66 7-1.73 1', key: '1ow05n' }],
  ['path', { d: 'm3.34 17 1.73-1', key: 'nuk764' }],
  ['path', { d: 'm3.34 7 1.73 1', key: '1ulond' }],
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
  ['circle', { cx: '12', cy: '12', r: '8', key: '46899m' }],
]);

export default Cog;
